import * as React from 'react';
import { Cell } from '../Cell';

type RenderCell = ReturnType<typeof Cell>;

type Props = {
  children: (RenderCell | RenderCell[])[] | RenderCell;
};

/**
 * @summary Обёртка для лучшей организации кода.
 *
 * @param props.children - Компоненты Cell.
 *
 * @description Зачем этот компонент:
 * 1. Row компонент удобнее использовать, так как не придётся проходить по всем ячейкам таблицы и проверять, нет ли там компонента редактирования.
 * 2. Когда используется таблица, проще обернуть ячейки в строку. Это выглядит понятнее.
 */
export const Row: React.FC<Props> = ({ children }) => <div>{children}</div>;

Row.displayName = 'Row';
export type RowType = typeof Row;
export type RowRender = React.FunctionComponentElement<Props>;
